"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Storage {
    static load(name) {
        var data = window.localStorage.getItem(name);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    }
    static save(name, data) {
        if (!data) {
            window.localStorage.removeItem(name);
        }
        else {
            window.localStorage.setItem(name, JSON.stringify(data));
        }
    }
}
exports.default = Storage;
